import { AutoComplete, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ROUTER_PATH } from "../../common/constant";
import {
  getCategories,
  selectCategories,
} from "../../redux/reducers/slice/category";
import { localizeRouteKey } from "../../shared/helpers";
import "./style.scss";

const SearchBar = (props: any) => {
  const categories = useSelector(selectCategories);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { history, closeModal } = props;
  const [dataRecommend, setDataRecommend] = useState<any>([]);

  useEffect(() => {
    if (!categories) {
      dispatch(
        getCategories({
          filters: { is_parent: { $ne: null }, is_public: true },
        })
      );
    }
  }, []);

  // useEffect(() => {
  //   if (categories && categories.length) {
  //     setDataRecommend(
  //       categories.map((item: any) => ({
  //         value: item.name || "",
  //         key: item.name_alias,
  //       }))
  //     );
  //   }
  // }, [categories]);

  const handleSearch = (e: any) => {
    const value = e.target.value;
    if (closeModal) {
      closeModal(false);
    }
    history.push(
      `${localizeRouteKey(ROUTER_PATH.SEARCH)}?${t("keyword")}=${value}`,
      { keyword: value }
    );
  };

  const handleSelect = (value: string, option: any) => {
    if (closeModal) {
      closeModal(false);
    }
    history.push(
      `${localizeRouteKey(ROUTER_PATH.SEARCH)}?${t("keyword")}=${value}`,
      { keyword: value }
    );
  };

  const handleChangeKeyword = (value: string) => {
    if (!value) {
      setDataRecommend([]);
      return;
    }

    if (categories && categories.length) {
      setDataRecommend(
        categories
          .filter(
            (m: any) =>
              m.name.toUpperCase().indexOf(value.toUpperCase()) !== -1 ||
              m.name_alias.toUpperCase().indexOf(value.toUpperCase()) !== -1 ||
              (m.keywords &&
                m.keywords.length &&
                m.keywords.filter(
                  (key: string) =>
                    key.toUpperCase().indexOf(value.toUpperCase()) !== -1
                ).length)
          )
          .map((item: any) => ({
            value: item.name || "",
            key: item.name_alias,
          }))
      );
    }
  };

  return (
    <div>
      <AutoComplete
        options={dataRecommend}
        onSelect={(value: string, option: any) => handleSelect(value, option)}
        style={{ width: "100%" }}
        onSearch={(value: string) => handleChangeKeyword(value)}
        // filterOption={(inputValue: any, option: any) => {
        //   return (
        // option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
        //   -1 ||
        // option.key.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        //   );
        // }}
        className="kd-input-search">
        <Input
          onPressEnter={(e: any) => handleSearch(e)}
          placeholder={t("placeholder_search")}
        />
      </AutoComplete>
    </div>
  );
};

export default SearchBar;
